<script lang="ts">
  import Flash, { type FlashState } from '#app/lib/components/flash.svelte'
  import { assertError } from '#app/lib/error'
  import type { OnOrOff } from '#app/types/html'
  import { I18n } from '#user/lib/i18n'
  import { testPassword } from '#user/lib/password_tests'

  let {
    title,
    password = $bindable(),
    flash = $bindable(),
    autocomplete = 'on',
  }: {
    title: string
    password: string
    flash?: FlashState
    autocomplete?: OnOrOff
  } = $props()

  let showPassword = $state(false)

  const togglePassword = () => showPassword = !showPassword

  function earlyVerifyPassword () {
    try {
      if (password) testPassword(password)
    } catch (err) {
      assertError(err)
      flash = err
    }
  }
</script>

<!-- Prefer on:input to bind:value as "'type' attribute cannot be dynamic if input uses two-way binding" -->
<label class="main-label">
  <span>{title}</span>
  <input
    type={showPassword ? 'text' : 'password'}
    {autocomplete}
    oninput={() => flash = undefined}
    bind:value={password}
    onblur={earlyVerifyPassword}
    {title}
    name="password"
  />
</label>

<Flash bind:state={flash} />

<div class="show-password-wrapper">
  <label class="inline">
    <input
      type="checkbox"
      class="show-password"
      bind:checked={showPassword}
      onclick={togglePassword}
    />
    {I18n('Show password')}
  </label>
</div>

<style lang="scss">
  input{
    margin: 0;
  }
  input[type="checkbox"]{
    margin-inline-end: 0.5em;
  }
  .main-label span{
    font-size: 1rem;
    margin-block: 1em 0.2em;
    display: block;
  }
  .inline{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .show-password-wrapper{
    padding: 0.5em 0;
    display: flex;
    align-items: center;
  }
  .show-password{
    /* otherwise chrome do not display any checkbox */
    appearance: auto;
  }
</style>
